var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.943,
    height: 90.553,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-462.5 -313.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 50",
    width: 65.758,
    height: 87.553,
    rx: 6,
    transform: "translate(464 315)",
    fill: "none",
    stroke: "#5300f2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    fill: "none",
    stroke: "#5300f2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M475.508 329.385h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 17",
    fill: "none",
    stroke: "#5300f2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M475.508 345.824h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 18",
    fill: "none",
    stroke: "#5300f2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M475.508 379.824h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 19",
    fill: "none",
    stroke: "#5300f2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M475.508 387.824h42.743"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 20",
    fill: "none",
    stroke: "#5300f2",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M475.508 337.604h42.743"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 51",
    width: 53,
    height: 20,
    rx: 3,
    transform: "translate(484.443 353.277)",
    fill: "#5300f2"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": ".PPT",
    transform: "translate(498.443 367.277)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "SegoeUI-Semibold, Segoe UI",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".PPT")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.ecc7dd3124f22c969b48068dae354b1b.svg";
export { ForwardRef as ReactComponent };